import { useState } from 'react';
import { deepReads } from '@/mocks/hotNews';

const fullTexts: Record<string, string[]> = {
  d1: [
    '时间回到那条热搜的前一天。起初，它只是某个论坛里一条语气平淡的吐槽帖，抱怨某平台“满减后反而更贵”的促销规则。没有人预料到，这条帖子会在十几个小时内席卷全网。',
    '我们重建了传播时间线：发帖后约两小时，帖文被搬运到短视频平台，配以夸张标题二次剪辑；此后多位拥有百万粉丝的测评博主跟进实测，评论区情绪被迅速点燃，话题冲上平台热搜。',
    '真正让事件“破圈”的，是一次当事人亲自下场录制回应视频。视频里没有打官腔，反而坦诚承认规则确有信息差，并承诺整改。这种“接得住”的姿态，让不少原本带着火气前来的网友态度反转。',
    '复盘整条链路，我们会发现：情绪传播快于事实澄清，标题的吸睛程度决定了第一波扩散半径。而决定事件最终走向的，往往不是谁声量大，而是谁更早拿出可信的证据与诚恳的态度。',
  ],
  d2: [
    '这场危机从一句八个字、不带任何情绪的内部说明开始。当晚，舆情已经发酵了数小时，官方账号才上线发布了第一版回应，措辞克制、点到为止。',
    '第二天上午，第二版声明出现，新增了对涉事流程的详细描述与初步调查结论，并首次出现“我们深感抱歉”。语气从“说明情况”转向“承担责任”。',
    '次日傍晚的第三版，是整场事件的转折点：它列出了可执行的处理时间表、补偿方案，并附上了一条可以直接找到负责人的反馈渠道。措辞不再是声明，而更像一份整改承诺书。',
    '用逐字对比还原这48小时，我们能清晰看到一家机构在公共压力下的成长曲线：先守流程，再表立场，最后落到行动。围观者最在意的，从来不是漂亮话，而是字里行间有没有“把用户当回事”的实感。',
  ],
};

export default function DeepDive() {
  const [expanded, setExpanded] = useState<string | null>(null);

  return (
    <section id="deep" className="w-full scroll-mt-24 bg-background-50 py-12 md:py-16">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <div className="flex flex-col items-start justify-between gap-4 md:flex-row md:items-end">
          <div>
            <p className="flex items-center gap-2 text-xs font-semibold uppercase tracking-widest text-accent-600">
              <i className="ri-mic-line" aria-hidden="true" /> FULL REPORT
            </p>
            <h2 className="mt-2 font-display text-2xl font-black md:text-3xl">实况还原 · 全网热点深度解析</h2>
            <p className="mt-2 max-w-2xl text-sm text-foreground-600">不只是吃个热闹，我们把瓜切开来看——时间线、信源与来龙去脉，一次讲清楚。</p>
          </div>
        </div>

        <div className="mt-7 grid gap-6 lg:grid-cols-2">
          {deepReads.map((d) => {
            const isOpen = expanded === d.id;
            return (
              <article key={d.id} className="flex flex-col overflow-hidden rounded-2xl bg-background-100">
                <div className="relative aspect-[16/8] w-full overflow-hidden">
                  <img src={d.image} alt={d.title} className="h-full w-full object-cover object-top" />
                  <span className="absolute left-3 top-3 whitespace-nowrap rounded-full bg-accent-500 px-2.5 py-1 text-xs font-bold text-background-50">
                    {d.tag}
                  </span>
                </div>
                <div className="flex flex-1 flex-col p-4 md:p-6">
                  <div className="flex items-center gap-3 text-xs text-foreground-500">
                    <span className="flex items-center gap-1"><i className="ri-file-text-line" aria-hidden="true" />{d.wordCount}</span>
                    <span className="flex items-center gap-1"><i className="ri-time-line" aria-hidden="true" />{d.read}精读</span>
                    <span className="flex items-center gap-1"><i className="ri-calendar-line" aria-hidden="true" />{d.time}</span>
                  </div>
                  <h3 className="mt-2 font-display text-lg font-bold leading-7 text-foreground-950 md:text-xl">{d.title}</h3>
                  <p className="mt-2 text-sm leading-6 text-foreground-600">{d.summary}</p>

                  {isOpen && (
                    <div className="mt-4 space-y-3 rounded-xl bg-background-50 p-4">
                      {fullTexts[d.id].map((p, i) => (
                        <p key={i} className="text-sm leading-7 text-foreground-700">{p}</p>
                      ))}
                    </div>
                  )}

                  <button type="button" onClick={() => setExpanded(isOpen ? null : d.id)} className={`mt-auto inline-flex cursor-pointer items-center gap-2 whitespace-nowrap pt-4 text-sm font-semibold ${isOpen ? 'text-foreground-600' : 'text-primary-700 hover:text-primary-800'}`}>
                    {isOpen ? <><i className="ri-arrow-up-s-line" aria-hidden="true" /> 收起全文</> : <><i className="ri-book-open-line" aria-hidden="true" /> 开始精读全文</>}
                  </button>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}